import { Pipe, PipeTransform } from '@angular/core';
import { getFilePath } from 'src/app/utils';

@Pipe({
  name: 'filePath',
  standalone: true
})
export class FilePathPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    return getFilePath(value);
  }
}
